"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paperClip24 = exports.paperClip24Args = void 0;
// Note: This file is autogenerated from assets in the SVGs directory. Do not edit or commit.
/* eslint-disable */
exports.paperClip24Args = {};
exports.paperClip24 = function (args) {
    return "<svg width=\"24px\" height=\"24px\" id=\"Layer_2\" data-name=\"Layer 2\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\">\n    <defs>\n        <style>.cls-1{fill:none;stroke:#4f4c4d;stroke-miterlimit:10;stroke-width:2px;}</style>\n    </defs>\n    <path class=\"cls-1\" d=\"M19.73,12.3l-6.56,6.55v0a4.9,4.9,0,0,1-6.93-6.93h0l7.27-7.26h0a3.28,3.28,0,0,1,4.64,4.64h0l-6.56,6.56a1.74,1.74,0,0,1-2.45-2.46L15,7.58\"/>\n</svg>";
};
